<lv-spinning-container [busy]="!documentRenderingTerminated" [hideSpinner]="hideSpinner"
                       [message]="'Ladevorgang läuft'">
  <lv-document-viewer-toolbar
    *ngIf="!hideToolbar"
    [(zoomLevel)]="zoomLevel"
    [(rotation)]="rotation"
    [total]="pages ? pages.length : 0"
    [(current)]="currentPage" (currentChange)="scrollTo($event)"
    (executeAction)="executeAction.emit($event)"
    [actions]="actions"
    [disabled]="!documentProxy"
    [hideZoom]="hideZoom"
    [hideRotation]="hideRotation"
    [hidePager]="hidePager"
    [hideCustomActions]="hideCustomActions"
  ></lv-document-viewer-toolbar>
  <div class="lv-document-viewer-pages" (scroll)="scroll($event)" #scollContainer
       [style.height.px]="scrollContainerHeight">
    <lv-document-viewer-page *ngFor="let page of pages; index as i"
                             [type]="type"
                             [index]="i"
                             [documentProxy]="documentProxy"
                             [zoomLevel]="zoomLevel"
                             [rotation]="rotation"
    ></lv-document-viewer-page>
  </div>
</lv-spinning-container>
